import { UserRole } from "configs/constants";
import { doExportCsv } from "helper/export";
import { allowPermission } from "helper/util";
import { selectRole } from "modules/auth/store/authSlice";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import paginationFunc from "../../../../helper/hooks/pagination";
import { withFetchTablePagination } from "../../../../hocs/withFetchAll";
import AdminClientHeader from "modules/admin/clients/components/header/AdminClientHeader";
import AdminUserTerritoryTable from "../components/table/AdminUserTerritoryTable";
import { getUserList } from "../store/thunks";
import {
  selectAllUsers,
  selectMetadata,
  updatePaginationUsers
} from "../store/userSlice";
import "../styles/commonUser.scss";

import { selectFilter, updateFilterUsers } from "../store/userSlice";
import FilterAdminUser from "../components/header/FilterAdminUser";
import { buildFirstLevelFilter } from "modules/admin/clients/helper";

const params = { group: "territory" };

const AdminUserTerritoryList = () => {
  const [showFilter, setShowFilter] = useState(false);
  const filter = useSelector(selectFilter);
  const dispatch = useDispatch();
  const clientList = useSelector(selectAllUsers);
  const metadata = useSelector(selectMetadata);
  const pagination = paginationFunc(
    metadata,
    "Territory User",
    updatePaginationUsers,
    dispatch
  );
  const page = metadata?.currentPage || 1;
  const pageSize = metadata?.itemsPerPage || 10;
  const breadCrumbs = [{ text: "USERS" }, { text: "TERRITORIES" }];
  const buttonParams = allowPermission(useSelector(selectRole), [UserRole.ADMIN])
    ? {
        text: "Create Territory User",
        link: "/admin/users/territories/new"
      }
    : null;

  const handleExport = async () => {
    await doExportCsv({
      path: "admin/users/export?group=territory",
      name: "All Territory"
    });
  };
  const handleClickFilter = (values) => {
    dispatch(updateFilterUsers(values));
  };

  useEffect(() => {
    delete params?.clientType;
    if (filter?.clientType) {
      params.clientType = filter.clientType;
    }
    dispatch(
      getUserList({
        ...params,
        page,
        pageSize,
        filter: buildFirstLevelFilter(filter)
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, pageSize, filter]);
  return (
    <div className="admin-user-territory-list">
      <AdminClientHeader
        breadCrumbs={breadCrumbs}
        buttonParams={buttonParams}
        handleExport={handleExport}
        showFilter={showFilter}
        setShowFilter={setShowFilter}
      />
      {showFilter && (
        <FilterAdminUser
          defaultValues={filter}
          setShowFilter={setShowFilter}
          handleClickFilter={handleClickFilter}
          onReset={() => dispatch(updateFilterUsers(undefined))}
        />
      )}
      <div className="admin-content">
        <AdminUserTerritoryTable dataSource={clientList} pagination={pagination} />
      </div>
    </div>
  );
};
export default withFetchTablePagination(AdminUserTerritoryList, {
  fetchData: getUserList,
  selectMeta: selectMetadata,
  params
});
